import { AdminRoutes } from "@/data/enums/router";
import i18n from "@/i18n";
import store from "@/store";
import type { IMenuRoute } from "@/models/routes";

export function clientInvoicesTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_.all"),
      to: {
        name: `adminClientInvoicesAll`
      }
    },
    {
      label: i18n.t("_.paid"),
      to: {
        name: `adminClientInvoicesPaid`
      }
    },
    {
      /* Only brands with a nominated pending payment method provider can have
      clearing invoices – for everyone else the API rejects the
      `pending_payment_method` parameter, so the tab stays hidden */
      if: () => store.getters["brand/hasPaymentClearing"],
      label: i18n.t("_.paid_clearing"),
      to: {
        name: AdminRoutes.CLIENT_BILLING_PAYMENT_CLEARING_INVOICES
      }
    },
    {
      label: i18n.t("_.unpaid"),
      to: {
        name: AdminRoutes.CLIENT_BILLING_UNPAID_INVOICES
      }
    },
    {
      label: i18n.t("_.credited"),
      to: {
        name: `adminClientInvoicesCredited`
      }
    }
  ];
}

export function transactionsTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_.successful_payments"),
      to: {
        name: "adminClientSuccessfulPayments"
      }
    },
    {
      label: i18n.t("_.failed_payments"),
      to: {
        name: "adminClientFailedPayments"
      }
    },
    {
      label: i18n.t("_.refunds"),
      to: { name: "adminClientRefunds" }
    },
    {
      label: i18n.t("_.all"),
      to: {
        name: "adminClientAllTransactions"
      }
    }
  ];
}
